module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TopicsTopEntrance"
  }, [_c('div', {
    staticClass: "TopicsTopEntrance-header"
  }, [_c('div', [_vm._v("公共弹幕管理/详情")]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "width": "560px"
    },
    attrs: {
      "label-width": "120px",
      "model": _vm.queryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "弹幕内容"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.queryForm.content),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "content", $$v)
      },
      expression: "queryForm.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "弹幕类目"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.queryForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "categoryId", $$v)
      },
      expression: "queryForm.categoryId"
    }
  }, _vm._l((_vm.categoryOption), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "初始试用次数"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.queryForm.initialization),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "initialization", $$v)
      },
      expression: "queryForm.initialization"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "弹幕排序"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.queryForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "sort", $$v)
      },
      expression: "queryForm.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "字体颜色选择"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.queryForm.textColor),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "textColor", $$v)
      },
      expression: "queryForm.textColor"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "flex": "1",
      "margin-left": "12px"
    },
    model: {
      value: (_vm.queryForm.textColor),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "textColor", $$v)
      },
      expression: "queryForm.textColor"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "背景开始渐变色"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.queryForm.startColor),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "startColor", $$v)
      },
      expression: "queryForm.startColor"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "flex": "1",
      "margin-left": "12px"
    },
    model: {
      value: (_vm.queryForm.startColor),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "startColor", $$v)
      },
      expression: "queryForm.startColor"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "背景结束渐变色"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.queryForm.endColor),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "endColor", $$v)
      },
      expression: "queryForm.endColor"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "flex": "1",
      "margin-left": "12px"
    },
    model: {
      value: (_vm.queryForm.endColor),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "endColor", $$v)
      },
      expression: "queryForm.endColor"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "渐变角度"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": -360,
      "max": 360
    },
    model: {
      value: (_vm.queryForm.angle),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "angle", $$v)
      },
      expression: "queryForm.angle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "背景色预览"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "36px"
    },
    style: ({
      'background': ("linear-gradient(" + (_vm.queryForm.angle + 90) + "deg, " + (_vm.queryForm.startColor) + ", " + (_vm.queryForm.endColor) + ")")
    })
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9cd22194!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/BulletinManagement/PublicBulletinManagement/Detail/index.vue
// module id = 1108
// module chunks = 0